import React from 'react';
import { getURL } from '../utils/api';

// Development-only badge pinned to the bottom-left corner showing which backend
// the app is talking to: green = local backend, red = deployed (live) backend.
// position: fixed + pointer-events: none, so it never shifts layout or blocks clicks.
const isLocalHost = (url) => {
  try {
    const { hostname } = new URL(url);
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || /^(10|192\.168)\./.test(hostname);
  } catch (_) {
    return false;
  }
};

export default function DevBackendBadge() {
  if (process.env.NODE_ENV === 'production') return null;

  const url = getURL();
  const local = isLocalHost(url);
  const color = local ? '#16a34a' : '#dc2626';

  return (
    <div
      aria-hidden="true"
      title={local ? 'Using the LOCAL development backend' : 'Using the DEPLOYED (live) backend'}
      style={{
        position: 'fixed',
        left: 8,
        bottom: 8,
        zIndex: 2147483647,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 9999,
        background: color,
        color: '#fff',
        font: '600 11px/1.4 system-ui, -apple-system, Segoe UI, sans-serif',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        opacity: 0.92,
      }}
    >
      <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#fff' }} />
      {local ? 'Local development' : 'LIVE backend'} · {url.replace(/^https?:\/\//, '').replace(/\/$/, '')}
    </div>
  );
}
